export default __webpack_public_path__ + "static/media/luxembourg.432392db.svg";